import {
  Site as SiteType,
  SiteContext as SiteContextType,
  SiteModule as SiteModuleType,
  SiteModules as SiteModulesType
} from '@/types'

export const modules: Record<SiteModuleType, { label: string; homePath: string }> = {
  store: { label: 'Loja', homePath: '/' },
  enrollment: { label: 'Cursos', homePath: '/courses' }
}

const enrollmentRoutes: [string, SiteModuleType][] = [
  ['/accounts/students/[studentSiteProfileUid]/enrollments', 'enrollment'],
  ['/accounts/contract-payments', 'enrollment'],
  ['/courses', 'enrollment'],
  ['/applications', 'enrollment']
]
const storeRoutes: [string, SiteModuleType][] = [
  ['/accounts/orders', 'store'],
  ['/accounts/profiles', 'store'],
  ['/payments-calendar', 'store'],
  ['/[channel]', 'store'],
  ['/e', 'store'],
  ['/checkout', 'store'],
  ['/contract', 'store'],
  ['/express', 'store'],
  ['/pay', 'store'],
  ['/pay-by-link', 'store']
]
const contextRoutes: [string, SiteModuleType][] = [...enrollmentRoutes, ...storeRoutes]

const matchesRoute = (path: string, route: string) => path === route || path.startsWith(`${route}/`)

export const getSiteModules = (siteData?: SiteType | null): SiteModulesType => {
  const { schoolManagementConfiguration } = siteData || {}
  const { enrollmentStore, enrollmentStoreEnabled } = schoolManagementConfiguration || {}

  const store = !!siteData // TODO: No flag implemented to check if store module is active. Update after implementing the store module flag.
  const enrollment = !!enrollmentStore?.isActive && !!enrollmentStoreEnabled
  const enrollmentWorkspace =
    enrollment && !!enrollmentStore?.workspaceEnabled && !!enrollmentStoreEnabled

  return {
    store,
    enrollment,
    enrollmentWorkspace,
    defaultModule: store ? 'store' : enrollmentWorkspace ? 'enrollment' : null,
    hasMultipleModules: store && enrollmentWorkspace
  }
}

export const getSiteContextFromPath = (pathname?: string | null): SiteContextType => {
  const path = (pathname || '/').replace(/^\/_sites\/\[site\]/, '') || '/'

  const match = contextRoutes.find(([route]) => matchesRoute(path, route))
  return match ? match[1] : null
}

export const isWorkspaceModule = (modules: SiteModulesType, module?: string | null) =>
  module === 'store' ? modules.store : module === 'enrollment' ? modules.enrollmentWorkspace : false
